import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { HashRouter } from "react-router-dom";
import { Toaster } from "sonner";
import { AxiosInterceptor } from "./config/AxiosInstance";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <>
    <App />
    <Toaster
      position="top-right"
      reverseOrder={false}
      richColors={true}
      // theme="system"
      // closeButton={true}
      className="custom_toast"
    />
  </>
  // {/* </React.StrictMode> */}
);
